import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_COUPON_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAutomaticCouponSettingStatusAction = createAsyncThunk(
    'coupon/updateAutomaticCouponSettingStatusAction',
    async (automaticCouponType, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ AUTOMATIC_COUPON_SETTINGS_PATH }/${ automaticCouponType }/status`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAutomaticCouponSettingStatusSlice = createSlice({
    name: 'updateAutomaticCouponSettingStatusSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAutomaticCouponSettingStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAutomaticCouponSettingStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAutomaticCouponSettingStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAutomaticCouponSettingStatusState = (state) => state.coupon.updateAutomaticCouponSettingStatus;
export default updateAutomaticCouponSettingStatusSlice.reducer;
